var _mask, _g, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 11,
    width: 27,
    height: 26
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00049 11.6685H35.35V36.7501H9.00049V11.6685Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8229 11.6685L26.7264 13.972C30.4154 15.7264 32.8005 19.4953 32.8005 23.5753C32.8005 29.4335 28.0337 34.2003 22.1755 34.2003C16.3156 34.2003 11.5505 29.4335 11.5505 23.5753C11.5505 19.4936 13.9339 15.7247 17.6212 13.972L16.5281 11.6685C11.9551 13.8394 9.00049 18.5127 9.00049 23.5753C9.00049 30.8394 14.9097 36.7503 22.1755 36.7503C29.4396 36.7503 35.3505 30.8394 35.3505 23.5753C35.3505 18.5144 32.3942 13.8411 27.8229 11.6685Z",
    fill: "#2F2F5B"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 27,
    height: 30
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 36.75H35.35V7H9V36.75Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9 18.05H23.45V7H20.9V18.05Z",
    fill: "#2F2F5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.e1cffa04.svg";
export { ForwardRef as ReactComponent };